// src/authConfig.js
// MSAL credentials must be set as environment variables.
// Add REACT_APP_MSAL_CLIENT_ID and REACT_APP_MSAL_TENANT_ID to your .env file.

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MSAL_TENANT_ID}`,
    // Redirect back to the root of your SPA
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      piiLoggingEnabled: false,
      logLevel: 2, // Info
    },
  },
};

// Request OpenID Connect scopes and User.Read for profile data
export const loginRequest = {
  scopes: [
    'openid',
    'profile',
    'User.Read',
  ],
};
